import ForgotPassComponent from '@components/forgot-password';
import * as React from 'react';

export interface IForgotPassProps {}

export default function ForgotPass(props: IForgotPassProps) {
  return <ForgotPassComponent />;
}
